class Switch {
    constructor(opts = {}) {
        this.prevSlideEle = null;
        this.changeIndex = opts.changeIndex || function () { return -1; };
        this.activeCls = 'active';
    }

    // 切换元素的操作
    changeItem($ele, index, currItemIndex) {
        let { currSlideIndex, prevSlideIndex } = this.slideStateArr[index];

        if (currSlideIndex == prevSlideIndex) {
            return false;
        } else {
            this.modifySelectState(index, currSlideIndex, prevSlideIndex);
            this.changeIndex(currSlideIndex, this.slideListArr[index].eq(currSlideIndex), prevSlideIndex);
        }
        this.slideStateArr[index].prevSlideIndex = this.slideStateArr[index].currSlideIndex;
    }
    // 添加和移除样式
    toggleClass($ele, isAdd = false) {
        isAdd ? $ele.addClass(this.activeCls) : $ele.removeClass(this.activeCls);
    }
    // 修改样式
    modifySelectState(index, currSlideIndex, prevSlideIndex) {
        this.toggleClass(this.slideListArr[index].eq(currSlideIndex), true);
        // 修改前一个选项的样式
        if (prevSlideIndex != -1) {
            this.toggleClass(this.slideListArr[index].eq(prevSlideIndex));
        }
    }
    selectDefault(index) {
        // 如果输入的index超过了范围。就什么也不做
        if (index < 0 || index > this.slideLen - 1) {
            return false;
        }
        for (let item of this.slideListArr) {
            this.toggleClass(item.eq(index), true);
        }

    }
}

class BtnSwitch extends Switch {
    constructor(opts) {
        super(opts);
        let parentCls = opts.parentCls || '._btnList',
            itemCls = opts.itemCls || '._btnItem',
            self = this;

        let $parentList = $(parentCls);
        // 默认被选中的项

        this.prevSlideIndex = opts.defaultIndex >= 0 ? opts.defaultIndex : -1;
        this.multiGroupBtn = $parentList > 1; // 是否需有多组按钮
        // 激活的样式
        this.activeCls = opts.activeCls || 'active';
        this.slideListArr = []; // 保存下每一组按钮
        this.slideStateArr = []; // 保存当前每一组按钮切换状态的数组
        // 如果有多组同时变化，就生成一个保存每一组切换状态的数组
        $parentList.each((index, item) => {
            this.slideStateArr.push({
                currSlideIndex: -1,
                prevSlideIndex: this.prevSlideIndex
            });
            // 在每一项上绑定一个对应的序列。在有多组class相同时
            $(item).attr('data-index', index);
            this.slideListArr.push($(item).find(itemCls));
            this.slideLen = $(item).find(itemCls).length;
        });
        if (this.prevSlideIndex >= 0) {
            this.selectDefault(this.prevSlideIndex);
        }
        $(document)
            .on("click", itemCls, function () {
                // 根据是否有多组数据。把当前的元素的下标保存下来
                let index = $(this).parents(parentCls).attr('data-index');


                let currItemIndex = $(this).index();

                if ($(this).attr('data-type') == 'layTab') {
                    return;
                }
                self.slideStateArr[index].currSlideIndex = currItemIndex;
                self.changeItem(self, index, currItemIndex);
            });
    }

}

export {
    BtnSwitch
};